import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";
import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
} from "@components";

import { FORM_FIELDS } from "@constants/form";

const PROCUREMENT = FORM_FIELDS.PROCUREMENT_DETAILS.SPEC_PREPARATION;

export default function ApproverInfo() {
  const { t } = useTranslation();
  const { register, control, setValue } = useFormContext();
  return (
    <div className="py-10">
      <SectionHeader
        title={t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.APPROVER_INFO")}
      />
      <div className="d-flex flex-column gap-6 pt-10">
        <InputTextRow
          label="PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.NAME_OF_APPROVER"
          register={{
            ...register(PROCUREMENT.NAME_OF_APPROVER),
          }}
        />
        <InputDateControllerRow
          name={PROCUREMENT.APPROVE_DATE}
          label="PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.APPROVE_DATE"
          register={{
            ...register(PROCUREMENT.APPROVE_DATE),
          }}
          control={control}
        />
        <MultiFileRow
          control={control}
          name={PROCUREMENT.APPROVER_DOCS}
          register={register}
          setValue={setValue}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        />
      </div>
    </div>
  );
}
